import service from "@/api/service";
import { PointUserCSVGetRequest } from "@/api/analysis/point-user-csv/request";
import { DownloadCSVResponse } from "@/api/response";

/**
 * ポイント付与数・利用金額ユーザーCSV出力APIをコールします。
 *
 * @param getRequest ポイント付与数・利用金額ユーザーCSV出力APIのリクエストボディ
 * @return response
 */
export async function get(getRequest: PointUserCSVGetRequest) {
  const response = await service.postReceiveCSV(
    "/analysis-point-user-csv",
    getRequest
  );
  return response as DownloadCSVResponse;
}
